/** @module Enums */ /** typedoc */

/**
 * Naming Glossary: https://www.notion.so/landr/Status-844540f3e7aa4458a6a57580d0559a16
 *
 * distributionVipArtists -> Long term feature flag. do not remove.
 * distributionBeatportApproved -> Long term feature flag. do not remove.
 */
export enum FeatureFlagEnum {
    advancedPreview = 'M_AdvancedPreview',
    referenceMastering = 'M_ReferenceMastering',
    auth0 = 'E_Auth0',
    collaborationCaptcha = 'C_Captcha',
    billingNewSubscriptionsPages = 'B_NewSubscriptionsPages',
    distributeCropArtwork = 'D_CropArtwork',
    distributionArtistProfiles = 'D_ArtistProfiles',
    distributionBeatportApproved = 'D_BeatportApproved',
    distributionContributors = 'D_Contributors',
    distributionIsrcReuse = 'D_ISRC_Reuse',
    distributionProofOfRights = 'D_ProofOfRights',
    distributionReleaseDetails = 'D_ReleaseDetails',
    distributionUnifiedReleaseBillingFlow = 'D_UnifiedReleaseBillingFlow',
    distributionVipArtists = 'D_VipArtists',
    epicWaveforms = 'M_EpicWaveforms', // TODO: Deprecate keeping new code, remove old one
    fusebillPayment = 'B_FusebillPayment', // Backend Flag : forwarded via headers (don't use in Webapp)
    fusebillLazyMigration = 'B_FusebillMigrateFreemium', // Backend Flag : forwarded via headers (don't use in Webapp)
    libraryWaitzine = 'L_Waitzine',
    libraryLongPreview = 'L_LongPreview', // Backend Flag : forwarded via headers  (don't use in Webapp)
    newMasteringFlow = 'M_NewMasteringFlow', // TODO: Deprecate keeping new code
    masteringVideos = 'M_Videos', // TODO: CODE TO BE FULLY REMOVED MG-28630
    referrals = 'R_Summary',
    userProfile = 'E_UserProfile',
    versioningCards = 'V_Cards', // TODO: CODE TO BE FULLY REMOVED
    videoTrack = 'L_VideoTrack', // TODO: CODE TO BE FULLY REMOVED MG-33698
    webappMigration = 'O_WebAppMigration',
}
